import api from "../api";

const endpoint = "/volontariat/Ami";
export const AMIService = {
  async insert(data) {
    try {
      const result = await api.post(endpoint + "/create", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(input) {
    try {
      const result = await api.put(endpoint + "/update", input);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async findOneById(id) {
    try {
      const result = await api.get(endpoint + "/find_one", {
        params: { id_type: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async list(filtre) {
    try {
      const result = await api.get(endpoint + "/liste", {
        params: { filtre: filtre },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(id) {
    try {
      const result = await api.post(endpoint + "/delete", id);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
